module.exports = __webpack_public_path__ + "img/404_man.28f00e81.jpg";